import React, { useEffect, useState, useRef } from 'react';
import { db, auth } from '../firebaseConfig';
import { doc, getDoc, addDoc, collection, query, where, getDocs, updateDoc, setDoc, deleteField } from 'firebase/firestore';
import { useParams, Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import MenuBar from '../components/MenuBar';
import { BiSolidLike } from "react-icons/bi";
import { IoChatbubbles } from "react-icons/io5";
import { FiMoreHorizontal } from 'react-icons/fi';
import { IoArrowRedoSharp } from "react-icons/io5";
import { useSwipeable } from 'react-swipeable';
import { FaTrash } from "react-icons/fa";
import '../styles/OtherMemberProfile.css';
import { Timestamp } from 'firebase/firestore'; // 追加: FirebaseのTimestampをインポート

const OtherMemberProfile = () => {
  const { id } = useParams();
  const { state } = useLocation();
  const members = state?.members || [];
  const [profile, setProfile] = useState(null);
  const [user, loading, error] = useAuthState(auth);
  const [alreadyLiked, setAlreadyLiked] = useState(false);
  const [receivedLike, setReceivedLike] = useState(false);
  const [approved, setApproved] = useState(false);
  const [chatId, setChatId] = useState(null);
  const [modalImage, setModalImage] = useState(null);
  const [rejectedByUser, setRejectedByUser] = useState(false);
  const [isOptionsVisible, setIsOptionsVisible] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const [isLikeModalOpen, setIsLikeModalOpen] = useState(false); // モーダルの表示状態
  const [likeMessage, setLikeMessage] = useState(''); // メッセージ入力用のステート
  const [favorites, setFavorites] = useState([]); // お気に入りの状態管理
  const [userPosts, setUserPosts] = useState([]); // 自分の投稿を管理
  const navigate = useNavigate();
  const optionsRef = useRef(null);
  const [isDataLoaded, setIsDataLoaded] = useState(false); // データが完全にロードされたかを管理

  const resetStates = () => {
    setAlreadyLiked(false);
    setReceivedLike(false);
    setApproved(false);
    setChatId(null);
    setRejectedByUser(false);
  };

  const fetchProfile = async (memberId) => {
    const docRef = doc(db, 'members', memberId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      setProfile(docSnap.data());
    }

    // 自分の投稿を取得する
    const postsQuery = query(
      collection(db, 'posts'),
      where('userId', '==', memberId) // 自分の投稿だけを取得
    );
    const postsSnapshot = await getDocs(postsQuery);
    const postsData = postsSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    setUserPosts(postsData); // 投稿データを保存
  };

  // 自分の投稿をレンダリングする関数
  const renderUserPosts = () => {
    if (userPosts.length === 0) {
      return ;
    }

    return userPosts.map((post) => (
      <div key={post.id} className="user-post">
        <div className="post-header">
          <p className="post-user-name">{post.userName}</p>
          <p className="post-date">
  {new Date(post.createdAt.seconds * 1000).toLocaleDateString('ja-JP', {
    month: '2-digit',
    day: '2-digit'
  })}{' '}
  {new Date(post.createdAt.seconds * 1000).toLocaleTimeString('ja-JP', {
    hour: '2-digit',
    minute: '2-digit'
  })}
</p>

        </div>
        <div className="post-content">
          <p className="post-text">{post.text}</p>
          {post.image && <img src={post.image} alt="Post image" className="post-image" />}
        </div>
      </div>
    ));
    
  };

  const fetchFavoritesFromFirestore = async (memberId) => {
    try {
      const q = query(collection(db, 'favorites'), where('participants', 'array-contains', memberId));
      const querySnapshot = await getDocs(q);
      const favoriteItems = querySnapshot.docs.map((docSnapshot) => {
        const data = docSnapshot.data();
        return {
          docid: docSnapshot.id,
          ...data,
        };
      });
      setFavorites(favoriteItems);
    } catch (error) {
      console.error('Error fetching favorites:', error);
    }
  };

  const calculateAge = (birthday) => {
    if (!birthday) return '--';
    const birthDate = new Date(birthday);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const checkIfLiked = async (memberId) => {
    if (user) {
      const sentQuery = query(
        collection(db, 'likes'),
        where('from', '==', user.uid),
        where('to', '==', memberId)
      );
      const sentQuerySnapshot = await getDocs(sentQuery);
      if (!sentQuerySnapshot.empty) {
        const sentLikeDoc = sentQuerySnapshot.docs[0];
        if (sentLikeDoc.data().status === 'approved') {
          setApproved(true);
          const chatQuery = query(
            collection(db, 'chats'),
            where('participants', 'array-contains', user.uid)
          );
          const chatSnapshot = await getDocs(chatQuery);
          const chat = chatSnapshot.docs.find(doc => doc.data().participants.includes(memberId));
          if (chat) {
            setChatId(chat.id);
          }
        } else {
          setAlreadyLiked(true);
        }
      }

      const receivedQuery = query(
        collection(db, 'likes'),
        where('from', '==', memberId),
        where('to', '==', user.uid),
        where('status', '==', 'pending')
      );
      const receivedQuerySnapshot = await getDocs(receivedQuery);
      setReceivedLike(!receivedQuerySnapshot.empty);

      const approvedQuery = query(
        collection(db, 'likes'),
        where('from', '==', memberId),
        where('to', '==', user.uid),
        where('status', '==', 'approved')
      );
      const approvedQuerySnapshot = await getDocs(approvedQuery);
      if (!approvedQuerySnapshot.empty) {
        setApproved(true);
        const chatQuery = query(
          collection(db, 'chats'),
          where('participants', 'array-contains', user.uid)
        );
        const chatSnapshot = await getDocs(chatQuery);
        const chat = chatSnapshot.docs.find(doc => doc.data().participants.includes(memberId));
        if (chat) {
          setChatId(chat.id);
        }
      }
    }
  };

  const checkIfUserRejected = async (memberId) => {
    if (user) {
      const rejectedQuery = query(
        collection(db, 'likes'),
        where('from', '==', memberId),
        where('to', '==', user.uid),
        where('status', '==', 'rejected')
      );
      const rejectedQuerySnapshot = await getDocs(rejectedQuery);
      return !rejectedQuerySnapshot.empty;
    }
    return false;
  };

  const checkIfChatting = async (memberId) => {
    if (user) {
      const chatQuery = query(
        collection(db, 'chats'),
        where('participants', 'array-contains', user.uid)
      );
      const chatSnapshot = await getDocs(chatQuery);
      const chat = chatSnapshot.docs.find(doc => doc.data().participants.includes(memberId));
      if (chat) {
        setChatId(chat.id);
      }
    }
  };

  const checkIfHidden = async () => {
    if (user) {
      const memberNotDisplayRef = doc(db, 'member_not_display', id);
      const docSnap = await getDoc(memberNotDisplayRef);
      if (docSnap.exists() && docSnap.data()[user.uid]) {
        setIsHidden(true);
      } else {
        setIsHidden(false);
      }
    }
  };

  useEffect(() => {
    if (id) {
      resetStates();
      fetchProfile(id);
      checkIfHidden();
      fetchFavoritesFromFirestore(id); // プロフィール取得後にお気に入りを取得
    }
  }, [id]);

  useEffect(() => {
    if (id && user) {
      checkIfLiked(id);
      checkIfChatting(id);
      checkIfUserRejected(id).then(setRejectedByUser);
    }
  }, [id, user]);

  // いいねの処理
  const handleLike = async (withMessage = false) => {
    if (user) {
      const isRejected = await checkIfUserRejected(id);
      if (isRejected) {
        alert('このユーザーにはこれ以上いいねを送ることができません。');
        return;
      }

      const likeData = {
        from: user.uid,
        to: id,
        status: 'pending',
        createdAt: new Date(),
        check: false,
      };

      if (withMessage && likeMessage.trim() !== '') {
        likeData.message = likeMessage.trim();
      }

      try {
        await addDoc(collection(db, 'likes'), likeData);
        alert('いいねを送信しました');
        setAlreadyLiked(true);
        setIsLikeModalOpen(false); // モーダルを閉じる
      } catch (error) {
        console.error('Error sending like:', error.message);
      }
    } else {
      console.error('No user is authenticated');
    }
  };

  // モーダルを開く
  const openLikeModal = () => {
    setIsLikeModalOpen(true);
  };

  // モーダルを閉じる
  const closeLikeModal = () => {
    setIsLikeModalOpen(false);
  };

  const handleApprove = async () => {
    if (user) {
      try {
        const receivedQuery = query(
          collection(db, 'likes'),
          where('from', '==', id),
          where('to', '==', user.uid),
          where('status', '==', 'pending')
        );
        const receivedQuerySnapshot = await getDocs(receivedQuery);

        if (!receivedQuerySnapshot.empty) {
          const likeDoc = receivedQuerySnapshot.docs[0];
          await updateDoc(likeDoc.ref, {
            status: 'approved'
          });
          alert('マッチングしました！');
          setApproved(true);

          // チャットの作成
          const chatDocRef = await addDoc(collection(db, 'chats'), {
            participants: [user.uid, id],
            createdAt: new Date()
          });
          setChatId(chatDocRef.id);
        }
      } catch (error) {
        console.error('Error approving like:', error.message);
      }
    }
  };

  const handleReject = async () => {
    if (user) {
      try {
        const receivedQuery = query(
          collection(db, 'likes'),
          where('from', '==', id),
          where('to', '==', user.uid),
          where('status', '==', 'pending')
        );
        const receivedQuerySnapshot = await getDocs(receivedQuery);

        if (!receivedQuerySnapshot.empty) {
          const likeDoc = receivedQuerySnapshot.docs[0];
          await updateDoc(likeDoc.ref, {
            status: 'rejected'
          });
          alert('Like rejected.');
          setReceivedLike(false);
          setRejectedByUser(true);
        }
      } catch (error) {
        console.error('Error rejecting like:', error.message);
      }
    }
  };

  const openModal = (url) => {
    setModalImage(url);
  };

  const closeModal = () => {
    setModalImage(null);
  };

  const handlePreviousProfile = () => {
    if (members && members.length > 0) {
      const currentIndex = members.findIndex(member => member.id === id);
      if (currentIndex > 0) {
        navigate(`/other_member_profile/${members[currentIndex - 1].id}`, { state: { members } });
      }
    }
  };

  const handleNextProfile = () => {
    if (members && members.length > 0) {
      const currentIndex = members.findIndex(member => member.id === id);
      if (currentIndex < members.length - 1) {
        navigate(`/other_member_profile/${members[currentIndex + 1].id}`, { state: { members } });
      }
    }
  };

  const handleOptionsToggle = () => {
    setIsOptionsVisible(!isOptionsVisible);
  };

  const handleOptionSelect = async (option) => {
    if (option === 'hide' && user) {
      try {
        const memberNotDisplayRef = collection(db, 'member_not_display');
        const docRef = doc(memberNotDisplayRef, id);
        await setDoc(docRef, {
          [user.uid]: true
        }, { merge: true });
        alert('このユーザーに対し自分のプロフィールを非表示にしました。');
        setIsHidden(true);
      } catch (error) {
        console.error('Error hiding profile:', error.message);
      }
    } else if (option === 'unhide' && user) {
      try {
        const memberNotDisplayRef = collection(db, 'member_not_display');
        const docRef = doc(memberNotDisplayRef, id);
        await updateDoc(docRef, {
          [user.uid]: deleteField()
        });
        alert('このユーザーに対し自分のプロフィールの非表示を取り消しました。');
        setIsHidden(false);
      } catch (error) {
        console.error('Error unhiding profile:', error.message);
      }
    } else if (option === 'report') {
      navigate(`/report/${id}`);
    }
    setIsOptionsVisible(false);
  };

  const handleClickOutside = (event) => {
    if (optionsRef.current && !optionsRef.current.contains(event.target)) {
      setIsOptionsVisible(false);
    }
  };

  const getTimeMarkerClass = (useDate) => {
    if (!useDate) return 'gray';
  
    let useDateTime;
  
    // Firebase Timestamp オブジェクトの場合
    if (useDate instanceof Timestamp) {
      useDateTime = useDate.toDate(); // Timestamp を JavaScript Date に変換
    } else {
      console.log("Unknown use_date format:", useDate);
      return 'gray';
    }
  
    const now = new Date();
    const timeDifferenceInHours = (now - useDateTime) / (1000 * 60 * 60);
  
    if (timeDifferenceInHours <= 1) {
      return 'green';
    } else if (timeDifferenceInHours <= 24) {
      return 'blue';
    } else if (timeDifferenceInHours <= 72) {
      return 'orange';
    } else {
      return 'gray';
    }
  };
  
  
  
  const getTimeDifferenceLabel = (useDate) => {
    if (!useDate) {
      console.log("use_date is undefined or null");
      return '';
    }
  
    let useDateTime;
  
    // Firebase Timestamp オブジェクトの場合
    if (useDate instanceof Timestamp) {
      useDateTime = useDate.toDate(); // Timestamp を JavaScript Date に変換
    } else {
      console.log("Unknown use_date format:", useDate);
      return '';
    }
  
    if (isNaN(useDateTime)) {
      console.log("Invalid use_date:", useDate);
      return '';
    }
  
    const now = new Date();
    const timeDifferenceInHours = (now - useDateTime) / (1000 * 60 * 60); // 時間単位に変換
    const timeDifferenceInDays = timeDifferenceInHours / 24; // 日単位に変換
  
    if (timeDifferenceInHours <= 1) {
      return '1時間以内';
    } else if (timeDifferenceInHours <= 24) {
      return '24時間以内';
    } else if (timeDifferenceInDays <= 3) {
      return '3日以内';
    } else if (timeDifferenceInDays <= 7) {
      return '1週間以内';
    } else if (timeDifferenceInDays <= 30) {
      return '1ヶ月以内';
    } else {
      return '1ヶ月以上前';
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handlers = useSwipeable({
    onSwipedLeft: () => {
      handleNextProfile();
    },
    onSwipedRight: () => {
      handlePreviousProfile();
    },
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  const renderFavorites = () => {
    return (
      <div className="custom-results-list">
        <div className="custom-results-list-content-a">
          {favorites.map((favorite) => (
            <div key={favorite.docid} className="custom-result-item-a">
              {favorite.Poster && (
                <img
                  src={favorite.Poster}
                  alt={favorite.Title || favorite.volumeInfo?.title || favorite.trackName || favorite.title}
                />
              )}
              {!favorite.Poster && favorite.volumeInfo?.imageLinks?.thumbnail && (
                <img
                  src={favorite.volumeInfo.imageLinks.thumbnail}
                  alt={favorite.Title || favorite.volumeInfo?.title || favorite.trackName || favorite.title}
                />
              )}
              {!favorite.Poster && !favorite.volumeInfo?.imageLinks?.thumbnail && favorite.artworkUrl100 && (
                <img
                  src={favorite.artworkUrl100}
                  alt={favorite.Title || favorite.volumeInfo?.title || favorite.trackName || favorite.title}
                />
              )}
              <h3>{favorite.Title || favorite.volumeInfo?.title || favorite.trackName || favorite.title}</h3>
              <p>{favorite.volumeInfo?.authors?.join(', ') || favorite.artistName || favorite.Director}</p>
            </div>
          ))}
        </div>
      </div>
    );
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;
  if (!profile) return <div>Loading profile...</div>;

  return (
    <div className="other-member-profile-container-x" {...handlers}>
      <div className="other-member-profile-header">
        <div className="options-container" ref={optionsRef}>
          <FiMoreHorizontal className="options-icon" onClick={handleOptionsToggle} />
          {isOptionsVisible && (
            <div className="options-menu">
              {isHidden ? (
                <div onClick={() => handleOptionSelect('unhide')}>・このユーザーに対し自分のプロフィールの非表示を取り消す</div>
              ) : (
                <div onClick={() => handleOptionSelect('hide')}>・このユーザーに対し自分のプロフィールを非表示</div>
              )}
              <div onClick={() => handleOptionSelect('report')}>・通報</div>
            </div>
          )}
        </div>
        <img
          src={profile.photoURL || '/images/default.png'}
          alt="Profile"
          className="other-member-profile-image"
          onClick={() => openModal(profile.photoURL || '/images/default.png')}
        />
<div className="other-member-sub-images">
  {[profile.sub_photoURL_1, profile.sub_photoURL_2, profile.sub_photoURL_3, profile.sub_photoURL_4, profile.sub_photoURL_5].map((url, index) => (
    <img
      key={index}
      src={url || '/images/default.png'} // デフォルト画像を用意
      alt={`Sub ${index + 1}`}
      className="other-member-sub-image"
      onClick={() => openModal(url || '/images/default.png')} // クリックでモーダル表示
    />
  ))}
</div>


<div className="profile-details-left">
  <div className="profile-header">
    <h4 className="other-member-profile-name">{profile.name || '--'}</h4>
    <div className="time-info">
      <span className={`time-marker ${getTimeMarkerClass(profile.use_date)}`}></span>
      <span>{getTimeDifferenceLabel(profile.use_date)}</span>
    </div>
  </div>
  <p>{calculateAge(profile.birthday)}歳 | {profile.location} | {profile.sex}</p>
  <p>{profile.sexualOrientation}</p>
</div>


        {profile.hashtags && profile.hashtags.length > 0 && (
          <div className="other-member-profile-hashtags">
            {profile.hashtags.map((tag, index) => (
              <span key={index} className="other-member-profile-hashtag">{tag}</span>
            ))}
          </div>
        )}


      </div>
      <div className="profile-content">

<div className="other-member-profile-bio-s">
<p className="other-member-profile-bio">
          <h3 className="h3_profile">会う時の希望</h3>
          <br />
          {profile.hope || '--'}
        </p>
  <p className="other-member-profile-bio"> <h3 className="h3_profile">自己紹介文</h3><br></br>{profile.bio || '--'}</p>
  <div className="other-member-profile-details">

<br />
<h3 className="h3_profile">基本プロフィール</h3>
          {profile.birthday && (
            <p className="profile_row">
              <span className="profile_item">年齢:</span> 
              <span className="profile_content">{calculateAge(profile.birthday)}歳</span>
            </p>
          )}
          {profile.location && (
            <p className="profile_row">
              <span className="profile_item3">居住地:</span> 
              <span className="profile_content">{profile.location}</span>
            </p>
          )}
          {profile.sex && (
            <p className="profile_row">
              <span className="profile_item3">性別:</span> 
              <span className="profile_content">{profile.sex}</span>
            </p>
          )}            
          {profile.spectrum && (
            <p className="profile_row">
              <span className="profile_item3">Aceスペクトラム:</span> 
              <span className="profile_content">{profile.spectrum}</span>
            </p>
          )} 
          {profile.sexualOrientation && (
            <p className="profile_row">
              <span className="profile_item4">性的指向:</span> 
              <span className="profile_content">{profile.sexualOrientation}</span>
            </p>
          )}
          {profile.aim && (
            <p className="profile_row">
              <span className="profile_item4">利用目的:</span> 
              <span className="profile_content">
                {Array.isArray(profile.aim) ? profile.aim.join(', ') : profile.aim}
              </span>
            </p>
          )}
              {profile.partner_sex && (
                <p className="profile_row">
                  <span className="profile_item4">望む相手の性別:</span> 
                  <span className="profile_content">
                    {Array.isArray(profile.partner_sex) ? profile.partner_sex.join(', ') : profile.partner_sex}
                  </span>
                </p>
              )}
              
          {profile.hope && (
            <p className="profile_row">
              <span className="profile_item6">会う時の希望:</span> 
              <span className="profile_content">{profile.hope}</span>
            </p>
          )}
          <br />

{(profile.height || profile.figure || profile.sociability || profile.works || profile.educationc) && (
  <>
    <h3 className="h3_profile">詳細プロフィール</h3>
    {profile.height && (
      <p className="profile_row">
        <span className="profile_item">身長:</span> 
        <span className="profile_content">{profile.height}cm</span>
      </p>
    )}
    {profile.figure && (
      <p className="profile_row">
        <span className="profile_item">体型:</span> 
        <span className="profile_content">{profile.figure}</span>
      </p>
    )}
    {profile.income && (
      <p className="profile_row">
        <span className="profile_item">年収:</span> 
        <span className="profile_content">{profile.income}</span>
      </p>
    )}
    {profile.works && (
      <p className="profile_row">
        <span className="profile_item">職業:</span> 
        <span className="profile_content">{profile.works}</span>
      </p>
    )}
    {profile.educationc && (
      <p className="profile_row">
        <span className="profile_item">学歴:</span> 
        <span className="profile_content">{profile.educationc}</span>
      </p>
    )}

{profile.holiday && (
      <p className="profile_row">
        <span className="profile_item3">休日:</span> 
        <span className="profile_content">{profile.holiday}</span>
      </p>
    )}
  </>
)}

{profile.cohabitant && (
      <p className="profile_row">
        <span className="profile_item3">同居人:</span> 
        <span className="profile_content">{profile.cohabitant}</span>
      </p>
    )}


{profile.contact && (
      <p className="profile_row">
        <span className="profile_item">連絡頻度:</span> 
        <span className="profile_content">{profile.contact}</span>
      </p>
    )}


{profile.tobacco && (
      <p className="profile_row">
        <span className="profile_item3">タバコ:</span> 
        <span className="profile_content">{profile.tobacco}</span>
      </p>
    )}


{profile.alcohol && (
      <p className="profile_row">
        <span className="profile_item">お酒:</span> 
        <span className="profile_content">{profile.alcohol}</span>
      </p>
    )}

{(profile.skinship || profile.children_want || profile.children_have || profile.marital_status) && (
  <><br></br>
    <h3 className="h3_profile">恋愛・結婚について</h3>
             {profile.marriage_aim && (
                <p className="profile_row">
                  <span className="profile_item4">結婚に対する意思:</span> 
                  <span className="profile_content">{profile.marriage_aim}</span>
                </p>
              )}
               {profile.skinship && (
                <p className="profile_row">
                  <span className="profile_item6">スキンシップ許容:</span> 
                  <span className="profile_content">{profile.skinship}</span>
                </p>
              )}

              {profile.love_exist && (
                <p className="profile_row">
                  <span className="profile_item4">恋愛感情の有無:</span> 
                  <span className="profile_content">{profile.love_exist}</span>
                </p>
              )}
                              {profile.friendship_marriage && (
                <p className="profile_row">
                  <span className="profile_item4">友情結婚の希望:</span> 
                  <span className="profile_content">{profile.friendship_marriage}</span>
                </p>
              )}
    {profile.children_want && (
      <p className="profile_row">
        <span className="profile_item5">子供の希望:</span> 
        <span className="profile_content">{profile.children_want}</span>
      </p>
    )}
    {profile.children_have && (
      <p className="profile_row">
        <span className="profile_item5">子供の有無:</span> 
        <span className="profile_content">{profile.children_have}</span>
      </p>
    )}
    {profile.marital_status && (
      <p className="profile_row">
        <span className="profile_item4">結婚歴:</span> 
        <span className="profile_content">{profile.marital_status}</span>
      </p>
    )}
                    {profile.cohabiter_aim && (
                <p className="profile_row">
                  <span className="profile_item4">同居の希望:</span> 
                  <span className="profile_content">{profile.cohabiter_aim}</span>
                </p>
              )}
  </>
)}

</div>
</div>

</div>


<div className={`other-member-profile-container ${isDataLoaded ? 'is-loaded' : ''}`} {...handlers}>
  {/* 必要なデータが完全にロードされるまで、アクションを表示しない */}
  {!isDataLoaded ? (
    <div>Loading...</div>
  ) : (
<div className="other-member-profile-actions">
  {/* 処理が完了するまで何も表示しない */}
  {!isDataLoaded ? null : (
    approved || chatId ? (
      <div className="like-button-bar">
        <Link to={`/chat/${chatId}`} className="like-button">
          チャットする
        </Link>
      </div>
    ) : receivedLike ? (
      <div className="like-button-bar">
        <button
          className="like-button"
          onClick={handleApprove} // メッセージなしでいいねを送信
        >
          ありがとう
        </button>
        <button
          className="message-like-button"
          onClick={handleReject}// モーダルを開く
        >
          ごめんなさい
        </button>
      </div>
    ) : rejectedByUser ? (
      <div className="other-member-profile-button other-rejected">
        <FaTrash />
      </div>
    ) : alreadyLiked ? (
      <div className="like-button-bar">
        <p>いいね送信済み</p>
      </div>
    ) : (
      <div className="like-button-bar">
        <button
          className="like-button"
          onClick={() => handleLike(false)} // メッセージなしでいいねを送信
        >
          いいねを送る
        </button>
        <button
          className="message-like-button"
          onClick={openLikeModal} // モーダルを開く
        >
          メッセージ
        </button>
      </div>
    )
  )}
</div>


  )}
  {/* 他のコンテンツ */}
</div>
      {isLikeModalOpen && (
        <div className="like-modal-overlay">
          <div className="like-modal">
            <h3>メッセージを添えていいねを送りますか？<br />※個人情報の入力は禁止です。</h3>
            <textarea
              value={likeMessage}
              onChange={(e) => setLikeMessage(e.target.value)}
              placeholder="メッセージを入力してください(100文字以内)"
              className="like-modal-textarea"
            />
            <div className="like-modal-buttons">
              <button onClick={() => handleLike(true)} className="like-modal-button like-modal-button-primary">メッセージ付きで送信</button>
              <button onClick={() => handleLike(false)} className="like-modal-button like-modal-button-secondary">そのまま送信</button>
            </div>
            <button className="like-modal-close" onClick={closeLikeModal}>×</button>
          </div>
        </div>
      )}

      {modalImage && (
        <div className="modal" onClick={closeModal}>
          <span className="close" onClick={closeModal}>&times;</span>
          <img className="modal-content" src={modalImage} alt="Modal" />
        </div>
      )}
      <MenuBar />
    </div>
  );
};

export default OtherMemberProfile;
